import { useContext, useEffect } from "react";
import { STEP_GROUP_IDS } from "../../../../shared/config";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { fakeFormsDataKYCManual } from "../../../../../utils/fakeFormsData";
import { useStepHandler } from "../../../../../utils/hooks/useStepHandler";
import { CUSTOM_FIXED_INSTALMENT_AMOUNT } from "../components/FixedInstalmentAmount";
import { parseStringAmountWithUnitToNumber } from "../../../../../utils/formaters";
import { AssetType, PaymentMode } from "@nemuru-eng/js-api-client";
import { PatchAssetDetailsByLoanId } from "../../../../../utils/mappers/PatchAssetDetailsByLoanId";
import { useActionCallback } from "../../../../../utils/hooks/useActionCallback";
import { FLOW_MESSAGES } from "../../../../shared/components/flowMessages/components";

export const useCard = ({ STEP_GROUP_STEPS_ARRAY }) => {
  const {
    state: { loan },
    dispatch,
  } = useContext(ProcessContext);

  useEffect(() => {
    if (loan.asset_reference[0].type !== AssetType.CARD)
      dispatch({
        type: "SET_MODULE_SKIPPED",
      });
  }, []);

  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.Card;

  const sanitizeValues = (values) => {
    if (values.paymentMode === PaymentMode.END_OF_MONTH) {
      delete values.fixedInstalmentAmount;
      return values;
    }

    if (values.paymentMode === PaymentMode.FIXED_INSTALLMENT) {
      if (values.fixedInstalmentAmount === CUSTOM_FIXED_INSTALMENT_AMOUNT) {
        values.fixedInstalmentAmount = {
          amount: parseStringAmountWithUnitToNumber(
            values.customFixedInstalmentAmount
          ),
          currency: loan.loan_conditions.currency,
        };
        delete values.customFixedInstalmentAmount;
        return values;
      }
      values.fixedInstalmentAmount = {
        amount: Number(values.fixedInstalmentAmount),
        currency: loan.loan_conditions.currency,
      };
      delete values.customFixedInstalmentAmount;
      return values;
    }
    return values;
  };

  useActionCallback("PROCESS_PATCH_ASSET_DETAILS_BY_LOAN_ID_FULFILLED", () => {
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });

    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });

    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: FLOW_MESSAGES.SEND_OK.id },
    });
  });

  const onSubmitModule = (values) => {
    const sanitizedValues = sanitizeValues(values);
    const body = PatchAssetDetailsByLoanId.dehydrate({
      loanId: loan.id,
      assetType: loan.asset_reference[0].type,
      ...sanitizedValues,
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: {
        show: true,
      },
    });
    dispatch({
      type: "PROCESS_PATCH_ASSET_DETAILS_BY_LOAN_ID",
      payload: body,
    });
  };

  const currentModuleStepHandler = useStepHandler(
    onSubmitModule,
    fakeFormsDataKYCManual
  );

  const { manageGroup, submitStep, onBack, backButtonVisible, getStepData } =
    currentModuleStepHandler;

  const stepGroupStepToShow = manageGroup(
    CURRENT_STEP_GROUP,
    STEP_GROUP_STEPS_ARRAY
  );

  return {
    currentModuleStepHandler,
    stepGroupStepToShow,
    submitStep,
    onBack,
    backButtonVisible,
    getStepData,
  };
};
